(() => {
  const triggerByDialog = new WeakMap();

  const closeDialog = (dialog) => {
    if (dialog?.open) {
      dialog.close();
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const openButton = target.closest('[data-material-compare-open]');
    if (openButton) {
      const dialogId = openButton.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;

      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;

      openButton.setAttribute('aria-expanded', 'true');
      triggerByDialog.set(dialog, openButton);
      dialog.showModal();
      return;
    }

    const closeButton = target.closest('[data-material-compare-close]');
    if (closeButton) {
      closeDialog(closeButton.closest('[data-material-compare-dialog]'));
      return;
    }

    const dialog = target.closest('[data-material-compare-dialog]');
    if (dialog && target === dialog) {
      closeDialog(dialog);
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLElement) || !dialog.matches('[data-material-compare-dialog]')) return;

      const trigger = triggerByDialog.get(dialog);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      triggerByDialog.delete(dialog);
    },
    true
  );
})();
